






































import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      code: ""
    };
  },
  created() {
    this.code = this.$route.query.redeemCd.toString();
  },
  methods: {
    /**
     * 复制打开微信
     */
    copyFn(val) {
      var obj = {
        text: val,
        needOpenWexin: "0"
      };
      this.$bridge.NativeBridge("copyAction", obj, 0);
    }
  }
});
